export const rideDetailsActionLog = {
	title: 'Actions Log',
	noActions: 'No actions yet',
	errorMessage: 'Something went wrong',
	headerAction: 'Action',
	headerDetails: 'Details',
	headerCategory: 'Category',
	headerDateTime: 'Date & time',
	headerUser: 'User',
	paginationLabel: 'Table pagination',
	prevPage: 'Previous page',
	nextPage: 'Next page',
};
